import { 
  createRouter, 
  createWebHistory 
} from 'vue-router'

import NotFound from '../views/404'
import Quadrant from '../components/Quadrant'

export default createRouter({
  history       : createWebHistory(process.env.VUE_APP_BASE_URL),
  routes        : [
    {
      path      : '/',
      name      : 'main',
      component : Quadrant,
      props     : true
    },
    {
      path      : '/:slug',
      name      : 'quadrant',
      component : Quadrant,
      props     : true
    },
    {
      path      : '/404',
      name      : 'not-found',
      component : NotFound,
      props     : true
    },
    {
      path      : '/:pathMatch(.*)*',
      redirect  : {
        name    : 'not-found'
      }
    },
  ]
})
